var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDingding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    fill: "white",
    stroke: "#13C2C2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9311 12.9913C21.9011 13.1217 21.8231 13.3151 21.7151 13.546H21.7182L21.7061 13.5684C21.0762 14.9146 19.4325 17.556 19.4325 17.556L19.4251 17.538L18.9451 18.3745H21.2592L16.8382 24.2495L17.8429 20.2529H16.0208L16.6537 17.6101C16.1424 17.733 15.5364 17.9023 14.8196 18.1332C14.8196 18.1332 13.8507 18.6999 12.0272 17.0419C12.0272 17.0419 10.7973 15.958 11.5113 15.6882C11.8142 15.5728 12.9824 15.4258 13.9017 15.3029C15.1464 15.1351 15.9098 15.0451 15.9098 15.0451C15.9098 15.0451 12.0781 15.102 11.1693 14.9596C10.2604 14.8173 9.10724 13.3001 8.86125 11.9674C8.86125 11.9674 8.48181 11.2358 9.67863 11.5821C10.8754 11.9285 15.8288 12.9314 15.8288 12.9314C15.8288 12.9314 9.3877 10.9571 8.95721 10.4743C8.5283 9.9946 7.69603 7.84485 7.80401 6.52572C7.80401 6.52572 7.85053 6.19589 8.18947 6.28579C8.18947 6.28579 12.9524 8.45958 16.2083 9.65133C19.4656 10.8431 22.2969 11.4487 21.9311 12.9913Z",
    fill: "#13C2C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDingding);
export default __webpack_public_path__ + "static/media/Dingding.605caa37292125f9268222b3889625ed.svg";
export { ForwardRef as ReactComponent };